<template>
  <!-- 这个是编辑项目的页面 -->
  <div class="contain">
    <!-- 这里边是一个表单 -->
    <el-form ref="reference" :model="reference" size="small" label-width="80px" label-position="top" :rules="rules">
      <el-card class="box-card">
        <el-form-item label="头像">
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="handleAvatarSuccess" :data="{ file: 'file', model: '' }" ref="imageUrl">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="职业">
          <span style=" padding-left: 9px;color: #bbbbbb;">{{ userinfo.userTypeId == 4 ? '基金会' : '学协会' }}</span>
        </el-form-item>

        <el-form-item :label="userinfo.userTypeId == 4 ? '基金会名称' : '学协会名称'" prop="json.user">
          <el-col :span="13">
            <el-input v-model="reference.json.user"
              :placeholder="userinfo.userTypeId == 4 ? '请输入基金会名称' : '请输入学协会名称'"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="级别">
          <el-select v-model="reference.json.XLlevel" placeholder="请选择">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="联系人" prop="realname">
          <el-col :span="13">
            <el-input v-model="reference.realname" placeholder="请输入联系人"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="联系方式" prop="phone" style="position: relative;">
          <el-col :span="13">
            <el-input :disabled="true" v-model="reference.phone" placeholder="请输入联系方式"></el-input>
          </el-col>
          <div class="modifications">
            <el-button @click="$router.push('/changePhone')" type="info">修改</el-button>
          </div>
        </el-form-item>
      </el-card>

      <el-card class="box-card">
        <el-form-item label="机构公众号">
          <el-col :span="9">
            <el-input v-model="reference.json.official_account" placeholder="请输入机构公众号"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-col :span="7">
            <el-input v-model="reference.email" placeholder="请输入邮箱"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="官网地址">
          <el-col :span="7">
            <el-input v-model="reference.json.website" placeholder="请输入官网地址"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="办公地址">
          <el-col :span="7">
            <el-input v-model="reference.json.location" placeholder="请输入办公地址"></el-input>
          </el-col>
        </el-form-item>

        <el-form-item label="二维码">
          <el-upload name="file" class="avatar-uploader" :action="action" :show-file-list="false"
            :on-success="handleAvatarSuccessQrcode" :data="{ file: 'file', model: '' }" ref="qrcodeUrl">
            <img v-if="qrcode" :src="qrcode" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="附件">
          <!-- 这里是附件-->
          <div class="uploads-box">
            <el-upload class="upload-demo" :action="action" multiple :file-list="fileListFJ"
              :on-success="accessorySuccess" :data="{ file: 'file', model: '' }" ref="accessory"
              v-model="reference.json.enclosure" :limit="1" :before-remove="beforeremove">
              <el-button size="small" type="info">选择文件</el-button>
              <div class="box"></div>
            </el-upload>
            <span class="ticks">请上传TXT、DOC、XLS、PPT、DOCX、XLSX、PPTX、PDF
              等文件格式</span>
          </div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="reference.remarks" type="textarea" :rows="2" placeholder="请输入备注">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="background: #484c7f" @click="submitForm('reference')">保存</el-button>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>  
  
<script>
import { filteringInformation } from ".././../../utils/filtering";
export default {
  name: 'zj',
  data() {
    return {
      options: [],
      //上传图片
      reference: {
        json: {
          user: '',//联系人
          enclosure: "",//附件 
          file_name: '', //附件名称  
          qrcode: '',//二维码
          XLlevel: '',//级别   
          official_account: '',//机构公众号
          website: '',//官网地址
          location: '',//办公地址  
        },
        avatar: '', //头像 //require('../../../assets/image/avater.png')
        email: '',//邮箱 
        remarks: '', //备注  
        userTypeId: '', //用户身份id 
        phone: '',//联系方式   
        realname: '',//名称  realname   
      },
      rules: {
        realname: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
        ],
        'json.user': [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
      },
      action: `https://laravel.gongshicloud.com/api/index/upload`,
      imageUrl: "",
      qrcode: '',
      fileListFJ: [],
    }
  },
  created() {
    this.getCateList()
    this.userinfo = JSON.parse(localStorage.getItem("userinfo"))
    this.reference = filteringInformation(this.userinfo, this.reference, this.reference.json)
    this.imageUrl = this.reference.avatar
    this.qrcode = this.reference.json.qrcode
    if (this.reference.json.file_name != "" && this.reference.json.file_name != undefined && this.reference.json.file_name != null) {
      this.fileListFJ.push({ name: this.reference.json.file_name, url: this.reference.json.enclosure })
    }
  },
  methods: {
    //获取分类
    async getCateList() {
      const { data: data } = await this.$http.post("cate/list", { type: 6 })
      this.options = data.data
    },
    //头像上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.imageUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.imageUrl = URL.createObjectURL(file.raw);
      this.reference.avatar = res.data.url
    },
    //二维码上传成功
    handleAvatarSuccessQrcode(res, file, fileList) {
      if (res.code != 200) {
        this.$refs.qrcodeUrl.clearFiles()
        this.$message.error(res.message)
        return
      }
      this.$Loading.finish()
      this.qrcode = URL.createObjectURL(file.raw);
      this.reference.json.qrcode = res.data.url
    },
    //附件
    accessorySuccess(res, file, fileList) {
      if (res.code != 200) {
        this.$message.error(res.message)
        this.$refs.accessory.clearFiles()
        return
      }
      this.$Loading.finish()
      this.reference.json.enclosure = res.data.url
      this.reference.json.file_name = res.data.file_name
    },
    //删除附件
    beforeremove(res, file, fileList) {
      this.reference.json.enclosure = ''
      this.reference.json.file_name = ''
      this.fileList = []
    },

    // 滚动条定位到第一个校验失败的div的位置
    locateToErr() {
      setTimeout(() => {
        let errorDiv = document.getElementsByClassName('is-error')
        errorDiv[0].scrollIntoView()
      }, 0)
    },
    // 点击提交表单 
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getInfoExpert()
        } else {
          this.locateToErr()
          return false;
        }
      });
    },
    //提交接口
    async getInfoExpert() {
      const { data: data } = await this.$http.post("user/changeInfo", this.reference)
      this.reference = data.data
      location.reload()
      this.$message({
        message: data.message,
        type: 'success'
      });
      // this.$router.push('/home')
      // location.reload()
    },
    //返回
    backProject() {
      this.$router.back()
    }
  }
}
</script>

<style lang='less' scoped>
.contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 23px;

  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;

    h4 {
      font-size: 28px;
      color: #212529;
    }
  }

  .box-card {
    width: 100%;
    flex: 1;
    overflow-y: auto;
    margin-bottom: 40px;
  }

  // 上传图片
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 66px;
    height: 66px;
    line-height: 66px;
    text-align: center;
  }

  .avatar {
    width: 66px;
    height: 66px;
    display: block;
  }

  // 上传文件
  .uploads {
    display: flex;

    .upload-demo {
      display: flex;
      align-items: center;

      .el-button {
        border-radius: 6px 0 0 6px;
      }

      /deep/ .el-upload-list {
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
        width: 421px;
        height: 32px;
        margin-top: 1px;

        .el-upload-list__item {
          margin: 3px 0;
        }
      }
    }

    .ticks {
      color: #cc0808;
      font-size: 12px;
      margin-top: 10px;
      margin-left: 13px;
    }
  }

  //新的
  .uploads-box {
    position: relative;

    .upload-demo {
      align-items: center;

      .el-button {
        border-radius: 6px 0 0 6px;
      }

      .box {
        position: absolute;
        top: 1px;
        left: 80px;
        width: 421px;
        height: 32px;
        border: 1px solid #f0f0f0;
        border-radius: 0 6px 6px 0;
      }
    }

    .ticks {
      position: absolute;
      top: -10px;
      left: 500px;
      color: #cc0808;
      font-size: 12px;
      margin-top: 10px;
      margin-left: 13px;
    }
  }

  .modifications {
    position: absolute;
    top: 0;
    left: 860px;
  }
}
</style>